export default __webpack_public_path__ + "static/media/frame20x30-wood.a2589f76.jpg";